@for (link of pagination?.links || []; track link; let index = $index) {
  <button
    (click)="pageChange.emit(link)"
    [class.primary-button]="link.current"
    mat-flat-button
    >
    {{ link.index + 1 }}
  </button>
}
